export class Product {
  constructor(data) {
    this.id = data.id ?? 0;
    this.code = data.code ?? '';
    this.name = data.name ?? '';
    this.category = data.category ?? '';
    this.salesAmount = data.salesAmount ?? 0;
  }
}
